$(document).ready(function() {

  if($("body.temp_padel-shoes.temp_apparel").length != 0){
    setInterval(function () {
      if($("variant-radios .option_valur_inner input:checked").data("inventory") > 0){
        $(".product-form__submit.product_defalut_select_variant").show();
        $(".product-form__submit.product_defalut_select_variant").removeAttr("disabled");
        $(".product-form__submit.product_defalut_select_variant").find("span").text("ADD TO CART");
      }else{
        $(".product-form__submit.product_defalut_select_variant").hide();
      }
    }, 10);
  }

   if ($('.option_valur_inner input').length) {
    setInterval(() => {
      let inputs = document.querySelectorAll(".option_valur_inner input");
      let isSelected = Array.from(inputs).some(input => input.checked);
      if (!isSelected) {
         $('.product_buy_grid').removeClass('data-product-qty');
      }else {
         $('.product_buy_grid').addClass('data-product-qty');
      }
    }, 10);
   }
  
  if ($('.product_qty_grid').length) {
    $('.product_buy_grid').each(function() {
      var qty = $(this).data('product-qty');
      if (qty > 0) {
        $(this).addClass('data-product-qty');
      }else {
        $(this).removeClass('data-product-qty');
      }
    });
  }
  if ($('.discount_popup').length) {
      $('.discount_popup .discount_popup_toggle').click(function() {
          var fullHTML = $('.discount_popup_model')[0].outerHTML;
          $('.notifection_popup').html(fullHTML);
          $('.notifection_popup, .notifection_popup .discount_popup_model').fadeIn();
      });
  
      $('.notifection_popup').on('click', '.popup__close, .btn_gotit', function() {
          $('.notifection_popup, .notifection_popup .discount_popup_model').fadeOut(function() {
              $('.notifection_popup').empty();
          });
      });
  }
  
});

if ($('.notify_drop_main').length) {
    var notifyParent = document.querySelector('.notify_drop_main a');
    var notifyPopup = document.querySelector('.notify_drop_popup');
    var notifyClosed = document.querySelector('.notify_drop_close');

    if (notifyParent && notifyPopup && notifyClosed) {
        notifyParent.addEventListener('click', function() {
            notifyPopup.style.display = 'flex';
            document.querySelector('body').classList.add('bnotify_open');
        });

        notifyClosed.addEventListener('click', function() {
            notifyPopup.style.display = 'none';
            document.querySelector('body').classList.remove('bnotify_open');
        });
    }
}

if ($('.product_media_main .swiper-slide').length) {
  const swiperSlides = document.querySelectorAll('.product_media_main .swiper-slide');
  const oddSwiperSlides = Array.from(swiperSlides).filter((_, index) => index % 2 !== 0);
  if (oddSwiperSlides.length > 0) {
    oddSwiperSlides[oddSwiperSlides.length - 1].classList.add('active');
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const expertReviewDiv = document.querySelector('.expert_review_dis .metafield-rich_text_field');
  if (expertReviewDiv) { 
    function countChildElements(container) {
      return Array.from(container.children).filter(child => child.nodeType === Node.ELEMENT_NODE).length;
    }
  }
  if (expertReviewDiv && countChildElements(expertReviewDiv) > 1) {
    const readMoreSpan = document.createElement('span');
    readMoreSpan.className = 'read-more';
    readMoreSpan.textContent = 'Read more';
    const readLessSpan = document.createElement('span');
    readLessSpan.className = 'read-less';
    readLessSpan.textContent = 'Read less';
    readLessSpan.style.display = 'none';
    expertReviewDiv.appendChild(readMoreSpan);
    expertReviewDiv.appendChild(readLessSpan);

    readMoreSpan.addEventListener('click', function() {
        expertReviewDiv.classList.add('show-more');
        readMoreSpan.style.display = 'none';
        readLessSpan.style.display = 'inline';
    });

    readLessSpan.addEventListener('click', function() {
        expertReviewDiv.classList.remove('show-more');
        readMoreSpan.style.display = 'inline';
        readLessSpan.style.display = 'none';
    });
  }
});

if($('.product_media_slider').length){
function setProductMediaHeight() {
  if (window.innerWidth <= 1000) {
      var bodyWidth = document.querySelector('body').clientWidth;
      document.querySelector('.product_media_slider').style.height = bodyWidth + 100 + 'px';
    } else {
      document.querySelector('.product_media_slider').style.height = '';
    }
  }
setProductMediaHeight();
$(window).on('resize', function(){
  setProductMediaHeight();
});
  $(document).ready(function(){
    setProductMediaHeight();
  });
}



// image slider 
  
function adjustProductMediaHeight() {
  var elements = document.querySelectorAll('.product_media_main .swiper-slide');
  var ScrollbarMain = document.querySelector('.product_thumnel_scroll .product_thumnel_scroll_inner');
  var ScrollbarMainInput = document.querySelector('.product_thumnel_scroll input');

  if (elements.length >= 3) {
    var productMediaMain = document.querySelector('.product_media_slider').clientHeight;
    var mediaTotal = document.querySelector('.product_media_main').clientHeight;
    var mediaPercents = (productMediaMain * 100) / mediaTotal;
    ScrollbarMain.style.height = mediaPercents + '%';
    ScrollbarMainInput.value = mediaPercents;

    // Calculate total scroll height and scroll amount per click
    var elementScroll = document.querySelector('.product_media_slider');
    var totalScrollableHeight = elementScroll.scrollHeight - elementScroll.clientHeight;
    
    var scrollAmountPerClick;
    if (window.innerWidth <= 1000) {
      scrollAmountPerClick = totalScrollableHeight / 30;
    } else {
      scrollAmountPerClick = totalScrollableHeight / 20;
    }

    var rangeInput = document.getElementById("scrollInnerThumnel");
    var scrollInner = document.getElementById("scrollInner");

    rangeInput.addEventListener('input', function() {
      var inputRangeValue = rangeInput.value;
      var newHeight = inputRangeValue + "%";
      scrollInner.style.height = newHeight;
      elementScroll.scrollTop = (inputRangeValue / 100) * (elementScroll.scrollHeight - elementScroll.clientHeight);
      checkArrows();
    });

    var leftArrow = document.querySelector('.product_thumnel_arrow_left');
    var rightArrow = document.querySelector('.product_thumnel_arrow_right');

    leftArrow.addEventListener('click', function() {
      if (!leftArrow.disabled) {
        var currentScrollTop = elementScroll.scrollTop;
        var newScrollTop = Math.max(currentScrollTop - scrollAmountPerClick, 0);
        elementScroll.scrollTop = newScrollTop;
        rangeInput.value = (newScrollTop / totalScrollableHeight) * 100;
        var scrollInnerHeightPercentage = parseFloat(scrollInner.style.height) || 0;
        var newTopPercentage = (rangeInput.value - scrollInnerHeightPercentage) + "%";
        scrollInner.style.top = newTopPercentage;
        checkArrows();
      }
    });

    rightArrow.addEventListener('click', function() {
      if (!rightArrow.disabled) {
        var currentScrollTop = elementScroll.scrollTop;
        var newScrollTop = Math.min(currentScrollTop + scrollAmountPerClick, totalScrollableHeight);
        elementScroll.scrollTop = newScrollTop;
        rangeInput.value = (newScrollTop / totalScrollableHeight) * 100;
        var scrollInnerHeightPercentage = parseFloat(scrollInner.style.height) || 0;
        var newTopPercentage = (rangeInput.value - scrollInnerHeightPercentage) + "%";
        scrollInner.style.top = newTopPercentage;
        checkArrows();
      }
    });

    function checkArrows() {
      var currentScrollTop = elementScroll.scrollTop;
      if (currentScrollTop <= 0) {
        leftArrow.disabled = true;
        leftArrow.classList.add('disable');
      } else {
        leftArrow.disabled = false;
        leftArrow.classList.remove('disable');
      }
      if (currentScrollTop >= totalScrollableHeight) {
        rightArrow.disabled = true;
        rightArrow.classList.add('disable');
      } else {
        rightArrow.disabled = false;
        rightArrow.classList.remove('disable');
      }
    }
    checkArrows();

    const slider = document.querySelector('.product_media_slider');
    if (slider) {
      slider.addEventListener('scroll', () => {
        var sliderTop = slider.scrollTop;
        var sliderHeightPercentage = (sliderTop * 100) / mediaTotal;
        ScrollbarMain.style.top = sliderHeightPercentage + '%';
        checkArrows();
      });
    }

  } else {
    //console.log('Not enough elements to perform the operation');
  }
}

// adjustProductMediaHeight();
window.addEventListener('resize', adjustProductMediaHeight);
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function(){
    adjustProductMediaHeight();
  }, 1000)
});


// ============================================

if($('#color_variant_name').length){
  var colorVariantElement = document.querySelector('#color_variant_name');
  function logDataValue(event) {
    const target = event ? event.target : this;
    const dataValue = target.getAttribute('data-value');
    if (colorVariantElement) {
      colorVariantElement.textContent = dataValue;
    }
  }
  function setupRadioInputs() {
    const radioInputs = document.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(input => {
      input.addEventListener('change', logDataValue);
      if (input.checked) {
        logDataValue.call(input);
      }
    });
  }
  
  setupRadioInputs();
  const firstInput = document.querySelector('input[type="radio"]');
  if (firstInput) {
    colorVariantElement.textContent = firstInput.getAttribute('data-value');
  } else {
  }
}

if($('#product-specificationsInner').length){
  const originalUl = document.querySelector('#product-specificationsInner ul');
  const items = Array.from(originalUl.children);
  const itemsPerUl = Math.ceil(items.length / 3);
  const productSpecifications = document.getElementById('product-specificationsInner');
  for (let i = 0; i < 3; i++) {
      const newUl = document.createElement('ul');
      for (let j = 0; j < itemsPerUl; j++) {
          const item = items.shift();
          if (item) {
              newUl.appendChild(item);
          }
      }
      productSpecifications.appendChild(newUl);
  }
  productSpecifications.removeChild(originalUl);
}



if ($('fieldset.js.product-form__input input[type="radio"]').length) {
  document.querySelectorAll('fieldset.js.product-form__input input[type="radio"]').forEach(function(input) {
    input.addEventListener('change', function() {
      var inventoryValue = parseInt(this.getAttribute('data-inventory'), 10);
      var notifyValue = this.getAttribute('data-notify') === 'true';

      // Fetch DOM elements
      var productSelectBtn = document.querySelector('.product_select_btn');
      var productSoldOut = document.querySelector('.product_sold_out');
      var productFormInner = document.querySelector('.product_form_Inner');
      var productQtyGrid = document.querySelector('.product_qty_grid');
      var productBuyGrid = document.querySelector('.product_buy_grid');
      var soldOutBanner = document.querySelector('.sold_out_banner');
      var alertMain = document.querySelector('.alert_main');
      var productInventory = document.querySelector('.product__inventory');
      var notifyBtn = document.querySelector('.notify_btn');
      // var notifyDropMain = document.querySelector('.notify_drop_main');
      var dataProductQty = document.querySelector('.data-product-qty');

      // Reset all elements to their default states
      if (productSelectBtn) productSelectBtn.style.display = 'none';
      if (productSoldOut) productSoldOut.style.display = 'none';
      if (productFormInner) productFormInner.style.display = 'block';
      if (productQtyGrid) productQtyGrid.style.display = 'block';
      if (soldOutBanner) soldOutBanner.style.display = 'none';
      if (alertMain) alertMain.style.display = 'none';
      if (productInventory) productInventory.style.display = 'block';
      if (notifyBtn) notifyBtn.style.display = 'none';
      // if (notifyDropMain) notifyDropMain.style.display = 'block';
      if (productBuyGrid) productBuyGrid.classList.add('data-product-qty');
      if (productBuyGrid) productBuyGrid.classList.remove('out_of_stok');

      // Handle conditions based on inventory and notify values
      if (inventoryValue <= 0 && !notifyValue) {
        // if (productQtyGrid) productQtyGrid.style.display = 'none';
        if (productSoldOut) productSoldOut.style.display = 'block';
        if (productFormInner) productFormInner.style.display = 'none';
        // if (notifyDropMain) notifyDropMain.style.display = 'none';
        if (productInventory) productInventory.style.display = 'none';
        if (productBuyGrid) productBuyGrid.classList.add('data-product-qty');
        if (productBuyGrid) productBuyGrid.classList.remove('select_size');
        
      } else if (inventoryValue > 0 && !notifyValue) {
        if (productQtyGrid) productQtyGrid.style.display = 'block';
        if (productSoldOut) productSoldOut.style.display = 'none';
        if (productFormInner) productFormInner.style.display = 'block';
        // if (notifyDropMain) notifyDropMain.style.display = 'block';
        if (productInventory) productInventory.style.display = 'block';
        if (productBuyGrid) productBuyGrid.classList.add('data-product-qty');
        if (productBuyGrid) productBuyGrid.classList.remove('select_size');
        
      } else if (inventoryValue <= 0 && notifyValue) {
        if (productQtyGrid) productQtyGrid.style.display = 'none';
        if (productFormInner) productFormInner.style.display = 'block';
        if (productBuyGrid) productBuyGrid.classList.add('out_of_stok');
        if (soldOutBanner) soldOutBanner.style.display = 'block';
        if (notifyBtn) notifyBtn.style.display = 'block';
        if (productInventory) productInventory.style.display = 'none';
        if (alertMain) alertMain.style.display = 'block';
        // if (notifyDropMain) notifyDropMain.style.display = 'none';
        if (productBuyGrid) productBuyGrid.classList.remove('data-product-qty');
        if (productBuyGrid) productBuyGrid.classList.add('select_size');
      }
    });
  });
}
$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 200
    }, 500);
});

// var toTop = $('.accroding-title');
// toTop.on('click', function() {
//     setTimeout(function(){
//         $('html, body').animate({
//             scrollTop: $('.product_media_tab_title').offset().top - 300
//         }, 500, function() {
//             //console.log('top');
//         });
//     }, 350);
// });

// variant image change

if($(".swiper-slide").length != 0){
const swiperSlides = document.querySelectorAll('.swiper-slide');

swiperSlides.forEach(slide => {
  const img = slide.querySelector('img');
  const modalOpener = slide.querySelector('.product__modal-opener');
  const loadingSpinner = slide.querySelector('.loading-overlay__spinner');
  if (img && img.alt) {
    if ('loading' in HTMLImageElement.prototype) {
      img.setAttribute('loading', 'lazy');
    } else {
      img.onload = () => img.classList.add('loaded');
      img.src = img.dataset.src;
    }
    if (modalOpener) {
      modalOpener.addEventListener('click', function (e) {
        e.preventDefault();
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }
        setTimeout(() => {
          if (loadingSpinner) {
            loadingSpinner.classList.add('hidden');
          }
        }, 1000);
      });
    }
  }
});

function printCheckedValue() {
  const checkedInput = document.querySelector('input[name="Color"]:checked');
  if (checkedInput) {
    const dataImgValue = checkedInput.nextElementSibling.getAttribute('data-img');
    if (dataImgValue) {
      let firstMatchedSlide = null;
      swiperSlides.forEach((slide) => {
        const img = slide.querySelector('img');
        if (img && img.alt === dataImgValue) {
          slide.style.display = 'block';
          if (!firstMatchedSlide) {
            firstMatchedSlide = slide;
            firstMatchedSlide.style.gridColumn = '1 / 3';
          }
        } else {
          // slide.style.display = 'none';
        }
      });
    }
  } else {
    const swiperSlides = document.querySelectorAll('.swiper-slide');
    if (swiperSlides.length > 0) {
      const firstImage = swiperSlides[0].querySelector('img');    
      if (firstImage && firstImage.alt) {
        const firstImageAlt = firstImage.alt;
        let firstMatchedSlide = null;    
        swiperSlides.forEach((slide) => {
          const img = slide.querySelector('img');    
          if (img && img.alt === firstImageAlt) {
            slide.style.display = 'block';    
            if (!firstMatchedSlide) {
              firstMatchedSlide = slide;
              firstMatchedSlide.style.gridColumn = '1 / 3';
            }
          } else {
            // slide.style.display = 'none';
          }
        });
      }
    }
  }
}
const radioButtons = document.querySelectorAll('input[name="Color"]');
radioButtons.forEach(radio => {
  radio.addEventListener('change', printCheckedValue);
});
printCheckedValue();
}

// ================================================================================================


$(document).on('click', function (event) {
  // if ($(event.target).closest('.finel_sale_icon').length) {
  //   $('.finel_sale_Tag').toggleClass('active');
  // } else if ($(event.target).closest('.discount-offer svg').length) {
  //   $('.discount-offer svg').toggleClass('active');
  // } else if ($(event.target).closest('.price_question_inner').length) {
  //   $('.price_question_inner').toggleClass('active');
  // } 
  // else {
  //   $('.finel_sale_Tag').removeClass('active');
  //   $('.discount-offer svg').removeClass('active');
  //   $('.price_question_inner').removeClass('active');
  // }
  
  if ($(event.target).closest('.product_form_Inner .notify_btn form.needsclick.klaviyo-form .needsclick .needsclick.kl-private-reset-css-Xuajs1 > .needsclick.kl-private-reset-css-Xuajs1 > .needsclick.kl-private-reset-css-Xuajs1 > .needsclick.kl-private-reset-css-Xuajs1').length) {
    $('.product_form_Inner .notify_btn form.needsclick.klaviyo-form .needsclick .needsclick.kl-private-reset-css-Xuajs1 > .needsclick.kl-private-reset-css-Xuajs1 > .needsclick.kl-private-reset-css-Xuajs1 > div.needsclick.kl-private-reset-css-Xuajs1').css('display', 'block');
  }else {
    $('.product_form_Inner .notify_btn form.needsclick.klaviyo-form .needsclick .needsclick.kl-private-reset-css-Xuajs1 > .needsclick.kl-private-reset-css-Xuajs1 > .needsclick.kl-private-reset-css-Xuajs1 > div.needsclick.kl-private-reset-css-Xuajs1').css('display', 'none');
  }
});






// product description shoe more and less
  
// const hafDescription = document.getElementById('haf_description');
// const fullDescription = document.getElementById('full-description');
// const readMore = document.querySelector('.read-more-btn');

// const descriptionText = document.getElementById('full-description').innerHTML;
// const limitedText = descriptionText.substring(0, 300) + '...';

// hafDescription.innerHTML = limitedText;

// function toggleFullDescription() {
//   if (fullDescription.style.display === 'none') {
//     hafDescription.style.display = 'none';
//     fullDescription.style.display = 'block';
//     readMore.innerText = 'Read less'
//   } else {
//     hafDescription.style.display = 'block';
//     fullDescription.style.display = 'none';
//     readMore.innerText = 'Read more'
//   }
// }
  
// const hafDescription01 = document.getElementById('haf_description_meta');
// const fullDescription01 = document.getElementById('full-description-meta');

// const descriptionText01 = document.getElementById('full-description-meta').innerHTML;
// const limitedText01 = descriptionText01.substring(0, 250) + '... <button class="read-more-btn" onclick="toggleFullmeta()">Read more</button>';

// hafDescription01.innerHTML = limitedText01;

// function toggleFullmeta() {
//   if (fullDescription01.style.display === 'none') {
//     hafDescription01.style.display = 'none';
//     fullDescription01.style.display = 'block';
//   } else {
//     hafDescription01.style.display = 'block';
//     fullDescription01.style.display = 'none';
//   }
// }

